import * as React from 'react';
import * as moment from 'moment';

import { GridEventProps } from '../../components/grid/event';

const GridEventView: React.StatelessComponent<GridEventProps> = props => {
    const eventMoment = moment(props.event.eventDate);
    const backgroundStyle = {
        backgroundImage: `url(${props.event.calendarRollover})`
    };

    return (
        <li className={`ace-cal-grid-event ${props.event.calendarRollover ? 'ace-cal-grid-event-has-bg' : ''}`}>
            {props.event.calendarRollover &&
                <span className="ace-cal-grid-event-bg" role="presentation" style={backgroundStyle}></span>
            }
            <article className="ace-cal-grid-event-content stack-sm" aria-label={props.event.name}>
                <div className="stack-xs">
                    <h4 className="ace-cal-grid-event-name h1-secondary">
                        {
                            props.event.viewDetailCtaUrl ?
                                <a href={props.event.viewDetailCtaUrl}>
                                    {props.event.name}
                                </a>
                                : props.event.name
                        }
                    </h4>
                    <p className="ace-cal-grid-event-time h3-secondary">{props.event.eventTimeString}</p>
                </div>
                {props.event.hideCta ? null
                    : <p className="ace-cal-grid-event-cta"><a href={props.event.buyTicketCtaUrl} className="primary-link no-transform">{props.event.buyTicketCtaText ? props.event.buyTicketCtaText : props.text.buyTicketCtaDefaultText}</a></p>
                }
                {props.event.gridAvailabilityStatus ?
                    <p className="ace-cal-grid-status light small">{props.event.gridAvailabilityStatus}</p>
                    : null}
                {props.event.gridInformationStatus ?
                    <p className="ace-cal-grid-status light small">{props.event.gridInformationStatus}</p>
                    : null}
            </article>
        </li>
    );
}

export default GridEventView;